import { Icon } from "@chakra-ui/react";
import React from "react";

export const FacebookIcon = () => (
    <Icon viewBox="0 0 23 22" boxSize="22px">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 11C0 4.92487 5.14873 0 11.5 0C17.8513 0 23 4.92487 23 11C23 17.0751 17.8513 22 11.5 22C5.14873 22 0 17.0751 0 11ZM12.6987 17.4678V11.4832H14.4258L14.6546 9.42086H12.6987L12.7016 8.38865C12.7016 7.85076 12.755 7.56255 13.5627 7.56255H14.6424V5.5H12.9151C10.8403 5.5 10.11 6.50045 10.11 8.18288V9.42109H8.81667V11.4834H10.11V17.4678H12.6987Z" fill="#222C63"/>
    </Icon>
)
